import React from 'react';
import { createUniversalProvider } from '@shopify/react-universal-provider';

const NetworkContext = /*#__PURE__*/React.createContext(null);
const NetworkUniversalContext = /*#__PURE__*/React.createContext(null);
const NetworkUniversalProvider = createUniversalProvider('network-details', NetworkUniversalContext);

export { NetworkContext, NetworkUniversalContext, NetworkUniversalProvider };
